const priority =[
    "High",
    "Medium",
    "Low",
]

export default priority